module.exports = __webpack_public_path__ + "media/images/calendar/september-88aa5bc0c363b14930ed84dff22b7717.jpg";